import useNswagClient from '../../hooks/api/useNswagClient';
import { useContext, useState } from 'react';
import { GetStockResponse } from '../../app/services/api/generated';
import { UserContext } from '../../components/shared/useUser';
import { useTranslation } from 'react-i18next';
import StockOnHandBox from './components/StockOnHandBox';
import { StockFilterOptions } from './components/interfaces/StockFilterOptions';
import useLogError from '../../hooks/useLogError';
import PageTitle from '../../components/shared/PageTitle';
import PageArea from '../../components/shared/PageArea';

const StockOnHandPage = () => {
  const { t } = useTranslation('common');
  const { selectedStore } = useContext(UserContext);
  const { getStock } = useNswagClient();
  const [stockData, setStockData] = useState<GetStockResponse>({});
  const { logError } = useLogError();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const loadFilterData = (options: StockFilterOptions = {}) => {
    setIsLoading(true);
    const storeNumber = selectedStore?.storeNumber;

    if (options.storeFilters) {
      getStock('', options.search, options.fieldToSort, options.sortDirection, options.skip, options.take, options.filters, options.categoryFilters, options.storeFilters, options.hasRecentActivity, options.isMadeInStore)
        .then((result) => {
          if (result?.data) {
            setStockData(result.data);
          }
        })
        .catch((error) => {
          logError(error);
        })
        .finally(() => setIsLoading(false));
    }
    else if (storeNumber) {
      getStock(storeNumber, options.search, options.fieldToSort, options.sortDirection, options.skip, options.take, options.filters, options.categoryFilters, options.storeFilters, options.hasRecentActivity, options.isMadeInStore)
        .then((result) => {
          if (result?.data) {
            setStockData(result.data);
          }
        })
        .catch((error) => {
          logError(error);
        })
        .finally(() => setIsLoading(false));
    }
  };

  return (
    <PageArea>
      <PageTitle subTitle={t('stockOnHand.subTitle')}>{t('stockOnHand.title')}</PageTitle>
      <StockOnHandBox stockOnHands={stockData}
        loadData={loadFilterData}
        isLoading={isLoading} />
    </PageArea>
  );
};

export default StockOnHandPage;
